import { Box, Card } from "@mui/material";
import { FC, useRef } from "react";
import { v4 as uuidv4 } from 'uuid';

interface DropZoneProps {
    onSetModules: any;
}

const DropZone: FC<DropZoneProps> = ({
    onSetModules,
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);


    const handleDrop = (e: any) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        const newModule = files.map((file, index) => ({
            id: index + 1,
            name: '',
            width: 0,
            depth: 0,
            height: 0,
            description: '',
            image: [file],
            randomKey: uuidv4(),
        }));

        onSetModules((prevState: any) => [...prevState, ...newModule]);
    };


    const handleFileSelect = (e: any) => {
        const files = Array.from(e.target.files) as File[];
        const newFurniture = files.map((file, index) => ({
            id: index + 1,
            name: '',
            width: 0,
            depth: 0,
            height: 0,
            description: '',
            image: [file],
            randomKey: uuidv4(),
        }));

        onSetModules((prevState: any) => [...prevState, ...newFurniture]);
    };


    const handleDragOver = (e: any) => {
        e.preventDefault();
    };


    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, width: '100%' }}>
            <Card
                sx={{
                    backgroundColor: '#eac5be',
                    border: '3px solid #c85742',
                    width: '100%',
                    maxWidth: '1400px',
                    p: 2,
                    height: '200px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onClick={() => fileInputRef.current?.click()}
            >
                Przeciągnij zdjęcia tutaj lub kliknij, aby dodać
            </Card>
            <input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileSelect}
            />
        </Box>
    )
}

export default DropZone;